<section class="admin-users evp plc">

  <div class="admin-users__toolbar evp__toolbar">
    <div class="evp__filters">
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Quelle' ) %></span>
        <select class="field__input field__select" data-id="filter-source"></select>
      </label>
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Aktivität' ) %></span>
        <select class="field__input field__select" data-id="filter-activity"></select>
      </label>
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Schwierigkeit' ) %></span>
        <select class="field__input field__select" data-id="filter-difficulty">
          <option value=""><%= _lcs( 'Alle' ) %></option>
          <option value="easy"><%= _lcs( 'Leicht' ) %></option>
          <option value="moderate"><%= _lcs( 'Mittel' ) %></option>
          <option value="difficult"><%= _lcs( 'Schwer' ) %></option>
          <option value="expert"><%= _lcs( 'Sehr schwer' ) %></option>
          <option value="unknown"><%= _lcs( 'Ohne Angabe' ) %></option>
        </select>
      </label>
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Distanz' ) %></span>
        <select class="field__input field__select" data-id="filter-distance">
          <option value=""><%= _lcs( 'Alle Längen' ) %></option>
          <option value="5000"><%= _lcs( 'bis {km} km', { km: 5 } ) %></option>
          <option value="10000"><%= _lcs( 'bis {km} km', { km: 10 } ) %></option>
          <option value="20000"><%= _lcs( 'bis {km} km', { km: 20 } ) %></option>
          <option value="50000"><%= _lcs( 'bis {km} km', { km: 50 } ) %></option>
        </select>
      </label>
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Status' ) %></span>
        <select class="field__input field__select" data-id="filter-status">
          <option value=""><%= _lcs( 'Alle' ) %></option>
          <option value="published"><%= _lcs( 'Veröffentlicht' ) %></option>
          <option value="draft"><%= _lcs( 'Entwurf' ) %></option>
          <option value="archived"><%= _lcs( 'Archiviert' ) %></option>
        </select>
      </label>
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Dubletten' ) %></span>
        <select class="field__input field__select" data-id="filter-duplicates">
          <option value="exclude"><%= _lcs( 'Ausblenden' ) %></option>
          <option value="include"><%= _lcs( 'Mit anzeigen' ) %></option>
          <option value="only"><%= _lcs( 'Nur Dubletten' ) %></option>
        </select>
      </label>
    </div>
    <button type="button" class="btn btn--ghost btn--sm" data-id="btn-reload">
      <i class="icon icon--rotate-cw"></i> <%= _lcs( 'Aktualisieren' ) %>
    </button>
  </div>

  <p class="evp__truncated" data-id="truncated" hidden></p>

  <!-- Grid (or loading / empty / error message) is rendered here by TourList.js -->
  <div class="admin-users__state" data-id="tours-state"></div>

  <!-- Detail panel (web component) -->
  <tour-detail data-id="tour-detail"></tour-detail>

</section>
